import React from "react";
import SearchSelectBox from "../SearchSelectBox";
import { AgeGroup, ageGroupNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";

const AgeGroupSelect = (props:any) => {
    const { value, manageSelect, label, variant, isError, errorMessage, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
    { value: AgeGroup.AG_U18, name: t(ageGroupNaming[AgeGroup.AG_U18]) },
    { value: AgeGroup.AG_U17, name: t(ageGroupNaming[AgeGroup.AG_U17]) },
    { value: AgeGroup.AG_U16, name: t(ageGroupNaming[AgeGroup.AG_U16]) },
    { value: AgeGroup.AG_U15, name: t(ageGroupNaming[AgeGroup.AG_U15]) },
    { value: AgeGroup.AG_U14, name: t(ageGroupNaming[AgeGroup.AG_U14]) },
    { value: AgeGroup.AG_U13, name: t(ageGroupNaming[AgeGroup.AG_U13]) },
    { value: AgeGroup.AG_U12, name: t(ageGroupNaming[AgeGroup.AG_U12]) },
    { value: AgeGroup.AG_U11, name: t(ageGroupNaming[AgeGroup.AG_U11]) },
    { value: AgeGroup.AG_U10, name: t(ageGroupNaming[AgeGroup.AG_U10]) },
    { value: AgeGroup.AG_U9, name: t(ageGroupNaming[AgeGroup.AG_U9]) },
  ];

    return (
        <>
            <SearchSelectBox
            options={options}
            selectedValue={value}
            manageSelect={(e:any) => {manageSelect(e.value)}}
            label={label}
            variant={variant}
            isError={isError}
            errorMessage={errorMessage}
            disabled={isReadOnly}
            />
        </>
    );
}

export default AgeGroupSelect;